import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const LOGIN_URL = `${API_URL}/api/v1/users/login`
export const REGISTER_URL = `${API_URL}/api/v1/users/signup`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post<any>(LOGIN_URL, {
    email,
    password,
  })
}

// Server should return AuthModel
export function register(
  firstname: string,
  // lastname: string,
  email: string,
  password: string,
  role: string,
  FDCCode: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    // last_name: lastname,
    password,
    role,
    FDCCode,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}
